import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, PartyPopper } from 'lucide-react';
import { openIzzyApp, registrationOpensNativeApp } from '../../Utils/openIzzyApp';

function EmailVerified() {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state || {};
    const device = state.device || new URLSearchParams(location.search).get('device') || 'web';
    const fromMobileApp = registrationOpensNativeApp(device);

    const handleContinue = () => {
        if (fromMobileApp) {
            openIzzyApp();
            return;
        }
        navigate('/beta-subscription', {
            state: {
                user_id: state.user_id,
                email: state.email,
                requiresPaymentMethod: state.requiresPaymentMethod,
                addPaymentUrl: state.addPaymentUrl,
            },
        });
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-blue-50 dark:from-[#111920] dark:to-[#1B2731] px-4">
            <div className="max-w-md w-full bg-white dark:bg-[#222a32] rounded-2xl shadow-2xl p-8 text-center">
                {/* Success Icon */}
                <div className="flex justify-center mb-6">
                    <div className="bg-green-100 dark:bg-green-900/30 rounded-full p-4">
                        <CheckCircle className="w-16 h-16 text-green-600 dark:text-green-400" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                    Email Verified!
                </h1>

                {/* Message */}
                <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
                    {fromMobileApp
                        ? "Your email is verified. Continue in the IzzyAI app to sign in."
                        : "Your email address has been successfully verified. You're all set to continue with your IzzyAI journey."}
                </p>

                {/* Continue Button */}
                <button
                    onClick={handleContinue}
                    className="w-full bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] text-white font-bold py-4 px-6 rounded-full hover:opacity-90 transition-all duration-300 hover:scale-105"
                >
                    {fromMobileApp ? "Open IzzyAI app" : "Continue"}
                </button>

                {/* Additional Info */}
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-6 flex items-center justify-center gap-2">
                    <PartyPopper className="w-4 h-4 text-amber-500 dark:text-amber-400" aria-hidden />
                    <span>Welcome to IzzyAI!</span>
                </p>
            </div>
        </div>
    );
}

export default EmailVerified;





























